import React, { Component } from 'react'
import { Form, Checkbox, Grid, Header, Image, Icon, Button, Search} from 'semantic-ui-react'
import { connect } from 'react-redux'
import AddressForm from './addressForm'
import { DropDown } from '../formComponents/dropDown'
import CustomCheckBox from '../formComponents/checkBox'
import InputField from '../formComponents/inputField'
import { displayMasterItem } from "./util";
import * as actionCreators from '../actions'
import { deleteHeaderParty, saveNewParty, saveSameAs } from '../api/setFormData'
import { saveImporterField, saveNewManufacturer, removeAManufacturer, callManufacturerAutosuggestAPI } from '../api/setFormData'
import PscHeaderReason from "./headerReason";
import { get } from 'lodash'
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
import _ from 'lodash'
import { getCountryNameByCountryCode } from '../../util/countryList'
import MidModal from './midQryModal'
import { getActorSuggestions } from '../api/getEntrySummaryData'

const SameAsHeader = ({
  checkboxValue,
  handleCheckBoxChange,
  headerPartyType,
  label,
  disabled
}) => {
  if (headerPartyType === 'SELLER') return null
  return (
    <Form.Group>
      <CustomCheckBox
        label={label}
        value={checkboxValue}
        update={handleCheckBoxChange}
        disabled={disabled}
      />
    </Form.Group>
  )
}

class ImporterForm extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      midshownIndex: 0,
      showAllMids: false,
      showAddManfacc: false,
      newManfacIdz: "",
      midList_bv: {},
  }
  }
  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }

  render() {
    let {
      importerValues,
      updateActorFeild,
      updateActorAddress,
      updateHeaderPartyFeild,
      updateHeaderPartyAddress,
      saveHeaderParties,
      saveHeaderPartiesByHeaderId,
      updateHeaderParty,
      saveImporter,
      expandAll,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      saveConsignee,
      headerParties,
      isDisabled,
      removeHeaderItemParty,
      // BOND INFO
      addHeaderItemParty,

      updateField,related,
      bondInfoValues,
      updateBondInfoField,
      updateAdditionalBondInfoField,
      saveHeaderReason,
      USStatesList,
      usStateOfDestCode,
      fieldValidation,
      entryTypeInfo
    } = this.props
  
    const missingPartiesX = ['BUYER', 'SHIP_TO', 'STUFFER', 'SELLER', 'CONSOLIDATOR'].filter(aaa=>!(headerParties || []).map(abb=>abb.headerPartyType).includes(aaa));
    const midObjectToNewlyAddedManufacturer = (midObj) =>{
      saveNewManufacturer(midObj)
        .then((manresponse)=>{
          let newpartiesjustadded = _.get(manresponse,"data.eventMessage.newlyAddedActorId.list",[]);
          if(newpartiesjustadded && newpartiesjustadded.length == 1){
            let addressInfoIsMissing = !newpartiesjustadded[0].addressInfo || Object.keys(newpartiesjustadded[0].addressInfo).length ==0;
            if(addressInfoIsMissing){
              let newaddress = newpartiesjustadded[0].addressinfo;
              if(newaddress[0]){
                for(let item of newaddress){
                  newaddress[item.type] = item.information;
                }
              }
              newpartiesjustadded[0].addressInfo = newaddress;
            }

          }
          addHeaderItemParty(newpartiesjustadded,0);
          this.setState({ midshownIndex: manufacturerParties.length});
        });
  
    }
    
    let formDisabled = this.props.formDisabled;
    if(this.state.enableForm === true){
      formDisabled = false;
    }
    let manufacturerParties = headerParties.filter((a)=>{
      if(a.headerPartyType){
        return (a.headerPartyType.indexOf("MANUFACTURER")==0);
      }
    });   
    const allMidsInUi =  manufacturerParties.map(aaa=>aaa.mId);
    let referenceTypelocal = this.props.referenceType + "";
    if(referenceTypelocal.split("_").length == 3){
      referenceTypelocal=referenceTypelocal.split("_")[2];
    }
    let pscWarningAlertShow = this.selectedReasons.length<=0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')
    let hasPSCLineCodes = false;
    for(let onelinecode of _.get(this.props.pscData,"lineCodes",[])){
      hasPSCLineCodes |= onelinecode?.reasonCodes?.length;
    }
    let pscWithReasonCodeOnMerchandiseLineItem = !!((this.props.pscData?.headerCodes||[]).find(a=>a.key=="merchandise")?.reasonCodes||[]).length && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')
    pscWithReasonCodeOnMerchandiseLineItem |= hasPSCLineCodes;
    return (
      <div className='es-section' title={(!pscWithReasonCodeOnMerchandiseLineItem && pscWarningAlertShow)?"Must select a PSC reason before you can edit":""}>
        {
        (get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && 
          <PscHeaderReason 
          {...this.props} 
          totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
          selectedOptions={this.selectedReasons}
          saveHeaderReason={saveHeaderReason} 
          enableDisableFrom={this.enableDisableFrom}
          pscState={get(this.props, "pscState.value.state")}
          />
        }
        
        <div className="transportationformheader">
            <DropDown
              id='usStateOfDestCode'
              label='STATE OF ULTIMATE DESTINATION'
              isLabel={true}
              className='dropdown100'
              disabled={this.state.enableForm === true ? false : isDisabled('usStateOfDestCode')}
              data={USStatesList}
              text={displayMasterItem(usStateOfDestCode, USStatesList)}
              onChange={value => {
                updateField('usStateOfDestCode', value)
                saveImporterField('usStateOfDestCode', value)
              }}
            />
        </div>
        {/*MANUFACTURERS!*/}
        <div className="dashedContainer" style={{marginTop:'10px'}}>
          <div style={{display:"flex",justifyContent:'space-between'}}>
            <div>
              {!this.state.showAllMids && manufacturerParties.length > 1 && <>
                Manufacturer ({this.state.midshownIndex+1} / {manufacturerParties.length})
                <select onChange={(foo)=>{
                  
                  this.setState({midshownIndex:foo.target.selectedIndex})}}>
                {manufacturerParties.map((onemanf,ioii)=>{
                  let selectedd = this.state.midshownIndex==ioii;
                  return (
                    <option key={onemanf.name+" jjjjjkhhh "+ioii} selected={selectedd} onClick={()=>this.setState({midshownIndex:ioii})}>
                      {onemanf.name}
                    </option>
                  )
                })}
                </select>
              </>}
            </div>
            <div>
              {!(this.state.enableForm === true ? false : isDisabled('importerSection')) && <>
                {!this.state.showAddManfacc ?<>
                  <Icon name='factory' className='center'/>
                  <a onClick={()=>{this.setState({showAddManfacc:true,newManfacIdz:''})}} href="#">Add Manufacturer</a>
                </>:<>
                Manufacturer ID: <input placeholder="Type to search for MID..." onChange={(value)=>{
                    this.setState({showMidModalAdd:false});
                    let typedval = value.target.value || "";
                    callManufacturerAutosuggestAPI(typedval.toUpperCase()).then((response)=>{
                      for(let midObj of response.data.eventMessage.list || []){
                        for(let addtype of ['addressInfo','addressinfo']){
                          if(midObj[addtype]){
                            if(!midObj[addtype].find(a=>a.type=="COUNTRY") && midObj[addtype].find(a=>a.type=="COUNTRY_CODE")){
                              midObj[addtype].push({type: 'COUNTRY', information: 
                                getCountryNameByCountryCode (midObj[addtype].find(a=>a.type=="COUNTRY_CODE").information) || midObj[addtype].find(a=>a.type=="COUNTRY_CODE").information
                              });
                            }
                          }
                        }
                      }
                      this.setState({
                        midList_bv: {...this.state.midList_bv, [typedval.toUpperCase()]:response?.data?.eventMessage?.list || []},
                        
                        showMidList: true
                      })
                  
                    });
                    clearTimeout(window.GLOBAMANUFACTURERLISTSEARCHVAR)
                    window.GLOBAMANUFACTURERLISTSEARCHVAR = setTimeout(()=>{this.setState({showMidList:false})},10000)
                    this.setState({newManfacIdz:(typedval||"").toUpperCase()})}
                  }
                  value={this.state.newManfacIdz}
                    
                  />
                  &nbsp;
                  &nbsp;
                  <button style={{whiteSpace:'nowrap'}} href="#" onClick={()=>{
                    this.setState({showAddManfacc:false});
                    }}>
                    Cancel
                  </button>
                </>}
                {this.state.showAddManfacc && 
                    <div className="middropdown"> 
                    
                    {this.state.midList_bv && this.state.midList_bv[this.state.newManfacIdz] && this.state.midList_bv[this.state.newManfacIdz].length ==0 ?
                      <>No results Found...<br/></>:""  
                    }
                    {(this.state.midList_bv[this.state.newManfacIdz]||[]).map((midObj,iii)=>{
                      if(iii==16)return <React.Fragment key={this.state.newManfacIdz+""+midObj.mid+' '+iii}>
                          <span style={{ opacity: 0.6 }}>
                            More results available, please refine search
                          </span>
                        <br/></React.Fragment >;
                      if(iii>15)return <React.Fragment  key={this.state.newManfacIdz+""+midObj.mid+' '+iii}></React.Fragment >;
                     return <React.Fragment key={this.state.newManfacIdz+""+midObj.mid+' '+iii}>
                        <a className="dropdownlink"
                          onClick={()=>{
                            console.log('midObj: ', midObj);
                            this.setState({showMidList: false,
                              showAddManfacc:false
                            
                            });
                            midObjectToNewlyAddedManufacturer(midObj);
                          }}
                        >
                        <span style={{whiteSpace:'nowrap'}}>
                          {midObj.mid}: {(midObj.name || '').substr(0,35)}
                        </span>
                        </a>
                        <br/>
                      </React.Fragment>})}
                      {/* <button disabled={!this.state.newManfacIdz} style={{whiteSpace:'nowrap'}} onClick={()=>{
                        //new manufacturer string code
                        saveNewManufacturer({mid:this.state.newManfacIdz, firmName:"New "+(manufacturerParties.length+1)+" "+this.state.newManfacIdz})
                          .then((manresponse)=>{
                            let newpartiesjustadded = _.get(manresponse,"data.eventMessage.newlyAddedActorId.list",[]);
                          addHeaderItemParty(newpartiesjustadded,0);
                          });
                        this.setState({showMidList: false})
                        this.setState({showAddManfacc:false});
                        }}> */}

                        <Button className="newButton primaryBtn btnType1 mediumBtn" onClick={()=>this.setState({showMidModalAdd:true})} style={{"color":"#fff"}}>MID QUERY</Button>


                      {/* </button> */}
                    </div>
                  }
              </>}{/*enableForm */}



                {this.state.showMidModalAdd && <><MidModal 
                  loggedInUserEmail={_.get(this.props, 'userBasicInfo.email', '')}
                  closeIcon 
                  modalStartsOpened={true}
                  header={'MID QRY MODAL'}   
                  key='addMid' 
                  defaultMid={this.state.newManfacIdz}
                  parentCloseFunction={()=>{
                    this.setState({showMidModalAdd:false});
                  }}
                  callbackAfterCbp={(response)=>{
                    if((allMidsInUi||[]).includes(response?.responseParams?.manufacturerDetails?.mid))return;
                    callManufacturerAutosuggestAPI(response?.responseParams?.manufacturerDetails?.mid).then((getManufromAutosuggest)=>{
                      let manuThatJustgotadded = _.get(getManufromAutosuggest,"data.eventMessage.list[0]")
                      midObjectToNewlyAddedManufacturer(manuThatJustgotadded);
                    })
                  }}
                  brokerId={window.brokerId}
                  shipmentId={window.shipmentId}
                  saveToActorRefOnly={true}
                  savedInContextOf={"manage-Manufacturer-Mid-Modal"}
                /></>}
              &nbsp;
              &nbsp;
              &nbsp;
              {manufacturerParties.length>=2 && <>
                {this.state.showAllMids ?
                  <a style={{whiteSpace:'nowrap'}} href="#" onClick={()=>this.setState({showAllMids:false,midshownIndex:0})}>
                  <Icon name='minus' className='center'/>
                    Show Less
                  </a>
                :
                  <a style={{whiteSpace:'nowrap'}} href="#" onClick={()=>this.setState({showAllMids:true})}>
                    <Icon name='plus' className='center'/>
                    Show All
                  </a>
                }</>
              }
            </div>
          </div>

          {/* {JSON.stringify(manufacturerParties)} */}
          {headerParties.map((headerParty, index) => {
            if((this.state.midshownIndex != manufacturerParties.indexOf(headerParty)) && !this.state.showAllMids)return null;
            if(headerParty.headerPartyType && headerParty.headerPartyType.indexOf("MANUFACTURER")!=0)return null;
            let removemanbutton = null;
            if(!(this.state.enableForm === true ? false : isDisabled('importerSection'))  && manufacturerParties.length>=2){
              removemanbutton=<>
                <a style={{float:'left'}} href="#" onClick={()=>{
                  if(!window.confirm("ARE YOU SURE YOU WANT TO REMOVE "+headerParty.name+"?"))return;
                    removeAManufacturer(headerParty.headerId);
                    removeHeaderItemParty(headerParty.headerId)
                    if(this.state.midshownIndex>0){
                      this.setState({midshownIndex:this.state.midshownIndex-1});
                    }
                  }}>
                  <Icon
                    name='trash alternate outline'
                    className='center'
                  />
                  Remove {headerParty.name}
                </a><br style={{clear:'both'}}/>
              </>;
            }
            return (
          <React.Fragment
            key={index + headerParty.headerPartyType + 'Fragment'}
          >
            <AddressForm
              header={'HEADER PARTY - ' + headerParty.headerPartyType + ' - #' + (this.state.midshownIndex+1)}
              index={index}
              kxUserBasicInfo={this.props.kxUserBasicInfo}
              key={index + headerParty.headerPartyType}
              headerParties={headerParties}
              name={headerParty.headerPartyType}
              actorName={index}
              nameValue={headerParty.name}
              address={headerParty.addressInfo}
              updateActorAddress={updateHeaderPartyAddress}
              sameAs={headerParty.sameAs}
              pscWithReasonCodeOnMerchandiseLineItem={pscWithReasonCodeOnMerchandiseLineItem}
              updateActorFeild={updateHeaderPartyFeild}
              updateHeaderPartyFeild={updateHeaderPartyFeild}
                dontShowTheHeader={this.state.showAllMids}
                headerParty={headerParty}
              saveSameAs={saveSameAs}
              saveHeaderPartiesByHeaderId={saveHeaderPartiesByHeaderId}
              onBlur={() => saveHeaderPartiesByHeaderId(headerParty.headerId)}
              disabled={this.state.enableForm === true ? false : isDisabled('importerSection')}
              newValue={newValue}
              fieldName={fieldName}
              setINPUTID={setINPUTID}
              penClicked={penClicked}
              shipmentId={shipmentId}
              rbCounterID={rbCounterID}
              expanded={headerParty.sameAs !== 1 || expandAll}
              updateHeaderParty={updateHeaderParty}
              fieldValidation={fieldValidation}
              entryTypeInfo={entryTypeInfo}
                additionalBottomFields={removemanbutton}
            />
          </React.Fragment>
          )})}
        </div>{/*End dashedcontainer END MANUFACTURERS */}
        <AddressForm
          actorName='importer'
          header='IMPORTER OF RECORD NAME AND ADDRESS'
          disabled={this.state.enableForm === true ? false : isDisabled('importerSection')}
          nameValue={importerValues.importer.name}
          name={'importer'}
          headerParties={headerParties}
          headerParty={headerParties.find(a=>a.headerPartyType == "IMPORTER")}
          address={importerValues.importer.addressInfo}
          headerPartyHeaderId={importerValues.importer.importerId}
          ssnInformationplz={importerValues.importer.importerIdInfo}
          updateActorAddress={updateHeaderPartyAddress}
          updateActorFeild={updateActorFeild}
          onBlur={saveImporter}
          newValue={newValue}
          fieldName={fieldName}
          setINPUTID={setINPUTID}
          penClicked={penClicked}
          shipmentId={shipmentId}
          rbCounterID={rbCounterID}
          updateHeaderParty={updateHeaderParty}
          expanded={true || expandAll}
          entryTypeInfo={entryTypeInfo}
          fieldValidation={fieldValidation}
        />
        <>
          <h4 id="divFormFeildLabelES" className="ui header">
            4811 PARTY
          </h4>
            Reference Type: <b>{referenceTypelocal}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Reference Number: <b>{this.props.referenceNumber}</b>
        </>
        <AddressForm
          header='ULTIMATE CONSIGNEE'
          actorName='consignee'
          name={'consignee'}
          nameValue={importerValues.consignee.name}
          headerParties={headerParties}
          headerPartyHeaderId={importerValues.consignee.consigneeId}
          address={importerValues.consignee.addressInfo}
          ssnInformationplz={importerValues.consignee.consigneeIdInfo}
          updateActorAddress={updateHeaderPartyAddress}
          updateActorFeild={updateActorFeild}
          headerParty={headerParties.find(a=>a.headerPartyType == "CONSIGNEE")}
          expanded={
            importerValues.sameAsFlags.consigneeAsImporter !== 1 || true
          }
          disabled={this.state.enableForm === true ? false : isDisabled('importerSection')}
          onBlur={saveConsignee}
          newValue={newValue}
          fieldName={fieldName}
          setINPUTID={setINPUTID}
          updateHeaderParty={updateHeaderParty}
          penClicked={penClicked}
          shipmentId={shipmentId}
          rbCounterID={rbCounterID}
          entryTypeInfo={entryTypeInfo}
          fieldValidation={fieldValidation}
        />

        {headerParties.concat(missingPartiesX.map(missingType=>{
          return {headerPartyType:missingType, missingPartyDisplay: true}
        })).sort((part1, part2) => {
          const sortMapping = {
            BUYER: 1,
            SELLER: 2,
            STUFFER: 3,
            SHIP_TO: 4,
            CONSOLIDATOR: 5
          }
          if(sortMapping[part1.headerPartyType] && sortMapping[part2.headerPartyType]){
            return sortMapping[part1.headerPartyType] -sortMapping[part2.headerPartyType];
          }
          if(sortMapping[part1.headerPartyType]) return -1;
          if(sortMapping[part2.headerPartyType]) return 1;
          return 0;
        }).map((headerParty, index) => {
          if (headerParty.headerPartyType && headerParty.headerPartyType.indexOf("MANUFACTURER") == 0) return null;

          function capitalizeFirstLetter(val) {
            return String(val).charAt(0).toUpperCase() + String(val).slice(1);
          }
          const isAdding = this.state[`adding${headerParty.headerPartyType}`];
          if (headerParty.missingPartyDisplay) {
            return (<div style={{borderTop:'1px solid #ccc', marginTop: '8px'}} key={headerParty.headerPartyType + 'Fragment2'}>
              <Button key={headerParty.headerPartyType + "MISSING"}
                className="blue basic circular compact add-line-item-btn narrow"
                disabled={(this.state.enableForm === true ? false : isDisabled('importerSection')) || isAdding}
                onClick={() => {
                  this.setState({ [`adding${headerParty.headerPartyType}`]: true });
                  saveNewParty(headerParty.headerPartyType, {}, shipmentId, this.props?.engineBolInfo?.[1]?.manifestId)
                    .then((manresponse) => {
                      this.setState({ [`adding${headerParty.headerPartyType}`]: false });
                      const relevantObject = _.get(manresponse, "data.eventMessage.afterGraph.actor01[0]");
                      if (!relevantObject) {
                        alert("PARTY ADDITION FAILED! " + JSON.stringify(manresponse));
                        return;
                      }
                      let newObject = {};
                      newObject['name'] = relevantObject.data.NAME;
                      newObject['actorid'] = relevantObject.meta.id;
                      newObject['type'] = relevantObject.data.ACTOR_TYPE
                      newObject.addressinfo = [];
                      for (let oneField of ["STREET_NUMBER", "STREET_NAME", "CITY", "COUNTRY", "COUNTRY_CODE", "UNSTRUCTURED_STREET_ADDRESS", "POSTAL_CODE", "COUNTRY_SUB_ENTITY"]) {
                        // if (!relevantObject.data[oneField]) continue;
                        newObject.addressinfo[oneField] = relevantObject.data[oneField] || "";
                        newObject.addressinfo.push({
                          type: oneField,
                          information: relevantObject.data[oneField] || ""
                        });
                      }
                      newObject.addressInfo = newObject.addressinfo;
                      addHeaderItemParty([newObject], 0);
                    });
                }}
                onFocus={() => {
                }}
                style={{ marginTop: '15px' }}
              >
                {isAdding ? "Adding" : "Add"} {capitalizeFirstLetter((headerParty.headerPartyType || "N/A").toLowerCase())}
              </Button>

            </div>)
          }
          return (
          <React.Fragment
            key={index + headerParty.headerPartyType + 'Fragment'}
          >
            <AddressForm
              header={'HEADER PARTY - ' + headerParty.headerPartyType}
              index={index}
              key={index + headerParty.headerPartyType}
              headerParties={headerParties}
              name={headerParty.headerPartyType}
              actorName={index}
              headerParty={headerParty}
              nameValue={headerParty.name}
              address={headerParty.addressInfo}
              updateActorAddress={updateHeaderPartyAddress}
              sameAs={headerParty.sameAs}
              updateActorFeild={updateHeaderPartyFeild}
              updateHeaderPartyFeild={updateHeaderPartyFeild}
              saveSameAs={saveSameAs}
              onBlur={() => saveHeaderPartiesByHeaderId(headerParty.headerId)}
              disabled={this.state.enableForm === true ? false : isDisabled('importerSection')}
              newValue={newValue}
              entryTypeInfo={entryTypeInfo}
              fieldName={fieldName}
              headerPostContent={
                
                <Icon
                name='trash alternate outline'
                className='center'
                onClick={()=>{
                  if(!window.confirm(`Are you sure you want to delete ${headerParty.headerPartyType} ${headerParty.name}`))return;
                  deleteHeaderParty(shipmentId, headerParty.headerId).then((deletionObject)=>{
                    removeHeaderItemParty(headerParty.headerId);
                  });
                }}
              />
              }
              setINPUTID={setINPUTID}
              penClicked={penClicked}
              shipmentId={shipmentId}
              rbCounterID={rbCounterID}
              expanded={headerParty.sameAs !== 1 || expandAll}
              updateHeaderParty={updateHeaderParty}
              fieldValidation={fieldValidation}
            />
          </React.Fragment>
        )})}
        
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  engineBolInfo:state?.BOLInfo?.engineBolInfo?.engineBolRecord,
  bondInfoValues: state.BondInfo,
  importerValues: state.Importer,
  headerParties: state.Importer.headerParties,
  USStatesList: state.DropDownValues.USStatesList,
  fieldValidation: state.FieldValidation,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  entryTypeInfo: state.EntryTypeInfo,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  rbCounterID: state.FormValues.rbCounterID,
  shipmentId: state.FormValues.shipmentId,
  formDisabled: state.FormValues.formDisabled,
  expandAll: state.FormValues.expandAll,
  related: state.Importer.related,
  tabName: "parties",
  pscData: state.PSC,
  USStatesList: state.DropDownValues.USStatesList,
  usStateOfDestCode: state.Importer.usStateOfDestCode,
  referenceType: state.DescriptionOfMerchandise.referenceType,
  referenceNumber: state.DescriptionOfMerchandise.referenceNumber,
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImporterForm)